import { AddressTypeDto } from '../dialect-cloud-api/data-service-dapps-api';
import { IllegalArgumentError } from '../sdk/errors';
export var AddressType;
(function (AddressType) {
    AddressType["Email"] = "EMAIL";
    AddressType["PhoneNumber"] = "PHONE_NUMBER";
    AddressType["Telegram"] = "TELEGRAM";
    AddressType["Wallet"] = "WALLET";
})(AddressType || (AddressType = {}));
const addressTypeToAddressTypeDto = {
    [AddressType.Email]: AddressTypeDto.Email,
    [AddressType.PhoneNumber]: AddressTypeDto.PhoneNumber,
    [AddressType.Telegram]: AddressTypeDto.Telegram,
    [AddressType.Wallet]: AddressTypeDto.Wallet,
};
export function toAddressTypeDto(type) {
    const addressTypeDto = addressTypeToAddressTypeDto[type];
    if (!addressTypeDto) {
        throw new IllegalArgumentError(`Unknown address type ${type}`);
    }
    return addressTypeDto;
}
const addressTypeDtoToAddressType = {
    [AddressTypeDto.Email]: AddressType.Email,
    [AddressTypeDto.PhoneNumber]: AddressType.PhoneNumber,
    [AddressTypeDto.Telegram]: AddressType.Telegram,
    [AddressTypeDto.Wallet]: AddressType.Wallet,
};
export function toAddressType(type) {
    const addressType = addressTypeDtoToAddressType[type];
    if (!addressType) {
        throw new IllegalArgumentError(`Unknown address type ${type}`);
    }
    return addressType;
}
//# sourceMappingURL=addresses.interface.js.map